import templateUrl from './textChart.tpl.html';

export const textChart = {
    templateUrl,
    bindings: {
        chartModel: '<',
        hideTitle: '<',
        isPreview: '<',
        openHref: '<',
        filterAlias: '<',
    },
    controller: [
        'chartLoadedEvent',
        function (chartLoadedEvent) {
            const $ctrl = this;

            $ctrl.$onInit = $onInit;

            function $onInit() {
                chartLoadedEvent(0, $ctrl.chartModel?.sf_id);
            }
        },
    ],
};
